import './elsieAiSummary.scss';
import WidgetAiCitations from '../widgets/widget-elsie-ai/WidgetAiCitations';
import { SurveyCitation } from 'common/models/elsie-ai.model';

interface ElsieAISummaryCitationsProps {
  citations: SurveyCitation[];
  closeCitations: () => void;
}

export function ElsieAiSummaryCitations({ citations }: Readonly<ElsieAISummaryCitationsProps>) {
  return (
    <div className="elsie-summary-citations">
      <WidgetAiCitations citations={citations} />
    </div>
  );
}
